export default "__VITE_ASSET__yUF69zLu__"